import { external_address } from '../../../../public-config';
import { request } from '../api/http-library';

const googleCommon = {
  googleConnect: (action, callback) => {
    const requestParams = {
      host: external_address,
      method: 'POST',
      path: '/google-connect'
    };

    const requestBody = {
      action
    };

    request(requestParams, (response) => {
      if (response.error) {
        callback(response.error);
        return;
      }
      const {
        state,
        clientId,
        nonce,
        redirectUri
      } = response;

      const responseType = 'id_token token';
      const scope = 'email profile';
      const query = `?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}&state=${state}&response_mode=form_post&nonce=${nonce}`;
      const oauthEndpoint = 'https://accounts.google.com/o/oauth2/v2/auth';

      callback(null, oauthEndpoint + query);
    }, requestBody);
  },
  fetchUserData (accessToken, peopleApiKey, callback) {
    // TODO: catch error
    fetch(`https://people.googleapis.com/v1/people/me?personFields=photos,phoneNumbers&key=${peopleApiKey}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).then(response => response.json())
      .then(userPeopleData => callback(userPeopleData))
      .catch(err => {
        callback();
      });
  }
};

export default googleCommon;
